module.exports = __webpack_public_path__ + "static/media/157.58e9c41b.jpg";